import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight, HelpCircle } from "lucide-react";
import WeatherWizHowTo from "./WeatherWizHowTo";

export default function GameControls({
  currentDate,
  onDateChange,
  weatherType,
  weather,
  formatTime,
  seconds,
  isEmbedded = false,
}) {
  const [showInstructions, setShowInstructions] = useState(false);

  // Helper to check if a date is today
  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const toggleInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  return (
    <>
      {/* Main controls container */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          mb: 3,
        }}
      >
        {/* Date and help controls */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          {/* Date navigation */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              onClick={() => onDateChange(-1)}
              sx={{ color: "text.primary" }}
            >
              <ChevronLeft />
            </IconButton>
            <Typography
              sx={{
                mx: 1,
                color: "text.primary",
                fontSize: "1rem",
                fontWeight: 500,
              }}
            >
              {currentDate.toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
            </Typography>
            {!isToday(currentDate) && (
              <IconButton
                onClick={() => onDateChange(1)}
                sx={{ color: "text.primary" }}
              >
                <ChevronRight />
              </IconButton>
            )}
          </Box>

          {/* Help button */}
          <IconButton
            onClick={toggleInstructions}
            sx={{
              color: "action.active",
              "&:hover": { color: "primary.main" },
            }}
          >
            <HelpCircle size={24} />
          </IconButton>
        </Box>

        {/* Stats bar */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 3, sm: 4 },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: "text.secondary",
              fontSize: "0.9rem",
            }}
          >
            Time: {formatTime(seconds)}
          </Typography>

          {weather && weather.current && (
            <Typography
              variant="body1"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                color: "text.secondary",
                fontSize: "0.9rem",
              }}
            >
              Seattle{" "}
              {weatherType.icon({
                sx: { fontSize: "1.2rem" },
              })}{" "}
              {Math.round(weather.current.temp_f)}°F
            </Typography>
          )}
        </Box>
      </Box>

      {/* How to play modal */}
      <WeatherWizHowTo
        open={showInstructions}
        onClose={toggleInstructions}
        weatherType={weatherType}
        isEmbedded={isEmbedded}
      />
    </>
  );
}
